import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { useDispatch } from "react-redux";
import editIcon from "../../../assets/png/edit.png";
import { handleGetRequest } from "../../../services/GetTemplate";
import Modal from "../../../components/modal/Modal";
import { handleDeleteRequest } from "../../../services/DeleteTemplate";
import deleteIcon from "../../../assets/png/delete.png";
import viewIcon from "../../../assets/png/view.png";
import EditViewInventory from "../Components/EditViewInventory";
import Loading from "../../../components/Loader";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { InputSwitch } from "primereact/inputswitch";
import { handlePutRequest } from "../../../services/PutTemplate";
import { Dropdown } from "primereact/dropdown";
import NavigationComponent from "../../../components/NavigationComponent";
import Paginator from "../../../components/Paginator";
import { endPoints } from "../../../Config";
import { handlePatchRequest } from "../../../services/PatchTemplate";

const InventoryCart = () => {
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [allInventory, setAllInventory] = useState([]);
    const [displayDialog, setDisplayDialog] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [inventoryId, setInventoryId] = useState(null);
    const [inventoryFilter, setInventoryFilter] = useState("part");

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        partMakerName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        representative: { value: null, matchMode: FilterMatchMode.IN },
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
        verified: { value: null, matchMode: FilterMatchMode.EQUALS },
    });
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [switchModal, setSwitchModal] = useState(false);
    const [switchData, setSwitchData] = useState(null);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [statusValue, setStatusValue] = useState("all");
    const [filteredInventory, setFilteredInventory] = useState([]);

    const [recordCount, setRecordCount] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [quotationsCount, setQuotationsCount] = useState(0);

    const userIdStr = localStorage.getItem("rememberMe") === "y" ? localStorage.getItem("userDetails") : sessionStorage.getItem("userDetails");

    const userId = JSON.parse(userIdStr);
    const userRole = userId?.data?.role;

    const statusOptions = [
        { id: "all", name: "All" },
        { id: "active", name: "Active" },
        { id: "inactive", name: "Inactive" },
    ];
    const inventoryOptions = [
        // { id: "all", name: "All" },
        { id: "part", name: "Part" },
        { id: "vehicle", name: "Variant" },
    ];

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const onHide = () => {
        setDisplayDialog(false);
    };

    const handleEditInventory = (rowData) => {
        setDisplayDialog(true);
        setInventoryId(rowData?.partId);
    };
    // const handleViewPart = (rowData) => {
    //     setCurrentModal("EditView");
    //     setDisplayDialog(true);
    //     setIsEditAble(false);
    //     setPartsDataId(rowData?.partId);
    // };
    // const params = new URLSearchParams({
    //     Limit: recordCount,
    //     Page: currentPage,
    //     SearchText: "",
    //     IsVehicle: inventoryFilter === "part" ? 0 : 1,
    //     IsActive: statusValue === "all" ? "" : statusValue === "inactive" ? 0 : 1,
    // });
    // const getInventoryList = async () => {
    //     setLoading(true);
    //     // const response = await dispatch(handleGetRequest(`/api/v1/inventories/getAll?${params}`, false));
    //     const response = await dispatch(handleGetRequest(endPoints.getAllInventory(params), false));
    //     setQuotationsCount(parseInt(response?.data?.totalCount));
    //     setAllInventory(response?.data?.items);
    //     setLoading(false);
    // };

    // useEffect(() => {
    //     getInventoryList();
    // }, [inventoryFilter, statusValue, currentPage, recordCount]);

    // const getInventoryList = async () => {
    //     setLoading(true);
    //     const response = await dispatch(handleGetRequest(endPoints.getallParts(params), false));
    //     if (response) {
    //         setAllInventory(response?.data?.items || []);
    //         setTotalPageCount(Math.ceil(response?.data?.length / recordCount)); // Calculate total pages
    //     }
    //     setLoading(false);
    // };
    // useEffect(() => {
    //     getInventoryList();
    // }, [currentPage, recordCount, statusValue]);
    // useEffect(() => {
    //     const updatedResponse = allInventory?.filter((item) => {
    //         if (statusValue === "active") return item?.partIsActive;
    //         else if (statusValue === "inactive") return !item?.partIsActive;
    //         else return item;
    //     });
    //     setFilteredInventory(updatedResponse);
    // }, [statusValue, allInventory]);

    const getInventoryList = async () => {
        setLoading(true);
        const params = new URLSearchParams({
            PageSize: recordCount?.toString(),
            PageNumber: currentPage?.toString(),
            IsActive: statusValue === "all" ? "" : statusValue === "inactive" ? 0 : 1,
        });
        const response = await dispatch(handleGetRequest(endPoints.getallParts(params), false));
        if (response) {
            const totalCount = response?.data?.totalCount || 0;
            setAllInventory(response?.data?.items || []);
            setQuotationsCount(totalCount);
            setTotalPageCount(Math.ceil(totalCount / recordCount));
        }
        setLoading(false);
    };
    useEffect(() => {
        getInventoryList();
    }, [currentPage, recordCount, statusValue]);

    const handleDeleteInventory = async () => {
        setLoadingBtn(true);
        const response = await dispatch(handleDeleteRequest(endPoints.deletePart(modalData?.partId), true, true));
        if (response?.statusCode === 200) {
            getInventoryList();
        }
        setLoadingBtn(false);
        handleCloseModal();
    };
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value.replace(/^\s+/, ""));
    };

    const statusTemplate = (rowData) => {
        return (
            <div className="flex justify-content-center">
                <InputSwitch
                    className="edit-btn ml-1 mt-2"
                    checked={rowData.partIsActive == "1"}
                    onChange={() => {
                        handleSwitchModalOpen();
                        setSwitchData(rowData);
                    }}
                />
            </div>
        );
    };

    const actionTemplate = (rowData) => {
        return (
            <div className="flex justify-content-center">
                {/* {!userRole?.toLowerCase().includes("user") && (
                    <InputSwitch
                        className="edit-btn ml-3 mt-2"
                        checked={rowData.isActive == "1"}
                        onChange={() => {
                            handleSwitchModalOpen();
                            setSwitchData(rowData);
                        }}
                    />
                )} */}
                {!userRole?.roleName?.toLowerCase().includes("user") && (
                    <Button className="edit-btn ml-1 px-2" onClick={() => handleEditInventory(rowData)}>
                        <img src={editIcon} alt="Edit" />
                    </Button>
                )}{" "}
                {/* <Button className="edit-btn ml-1 px-2" onClick={() => handleViewPart(rowData)}>
                    <img src={viewIcon} alt="view" />
                </Button> */}
                {/* <Link to={{ pathname: `/inventorylogs/${rowData.inventoryId}` }} className="edit-btn ml-1 px-2 mt-3">
                    <img src={viewIcon} alt="View Details" />
                </Link> */}
                {!userRole?.roleName?.toLowerCase().includes("user") && (
                    <Button
                        className="edit-btn ml-1 px-2"
                        onClick={() => {
                            handleOpenModal();
                            setModalData(rowData);
                        }}
                    >
                        <img src={deleteIcon} alt="Delete" />
                    </Button>
                )}
            </div>
        );
    };

    const handleInputSwitch = async () => {
        setLoadingBtn(true);

        let newdata = {
            id: switchData?.partId,
            isActive: switchData?.partIsActive ? false : true,
        };

        const response = await dispatch(handlePatchRequest(newdata, endPoints.partStatus, false, true));

        if (response?.statusCode === 200) {
            getInventoryList();
        }
        setLoadingBtn(false);
        handleSwitchModalClose();
    };

    const handleSwitchModalOpen = () => {
        setSwitchModal(true);
    };
    const handleSwitchModalClose = () => {
        setSwitchModal(false);
    };

    const optionTemplate = (option) => {
        return <div className={option.className}>{option.name}</div>;
    };
    const selectedItemTemplate = (option) => {
        if (option) {
            return <div className={option.className}>{option.name}</div>;
        }
        return <span>Select Status</span>;
    };

    const partCostTemplate = (rowData) => {
        return rowData?.partCost;
    };
    // const variantCostTemplate = (rowData) => {
    //     return ` ${rowData?.variantCost} ${rowData?.variantCurrencyCode}`;
    // };

    const headerText = "Edit Inventory";
    const header = <span className="title-border">{headerText}</span>;

    return (
        <>
            {loading ? (
                <Loading />
            ) : (
                <>
                    <Dialog resizable={false} header={header} visible={displayDialog} blockScroll style={{ width: "40vw" }} onHide={() => onHide()} draggable={false}>
                        <EditViewInventory onHide={onHide} inventoryId={inventoryId} getInventoryList={getInventoryList} />
                    </Dialog>

                    <div>
                        <Modal isOpen={isModalOpen} onClose={handleCloseModal} onConfirm={handleDeleteInventory} rowData={modalData} type="delete" loadingBtn={loadingBtn} headerText="Are you sure you want to delete this Inventory?" />
                    </div>
                    <div>
                        <Modal
                            isOpen={switchModal}
                            onClose={handleSwitchModalClose}
                            onConfirm={handleInputSwitch}
                            type="active/inactive"
                            loadingBtn={loadingBtn}
                            rowData={switchData}
                            isActive={switchData?.partIsActive}
                            headerText={`Are you sure you want to ${switchData?.partIsActive ? "Inactive" : "Active"} this Inventory?`}
                        />
                    </div>

                    <NavigationComponent
                        title={`Inventory Cart`}
                        // isSearchBar
                        dropdownOptions={inventoryOptions}
                        dropdownValue={inventoryFilter}
                        dropdownOnChange={(e) => {
                            setInventoryFilter(e.target.value);
                        }}
                    />
                    <div className="card-ml-1 dark-bg">
                       <DataTable
    header={
        <div className="flex justify-content-end custom-alignment">
            <span className="mr-2 font-semibold text-base resp-status">Status:</span>
            <Dropdown
                style={{ width: "215px" }}
                options={statusOptions}
                optionLabel="name"
                optionValue="id"
                value={statusValue}
                onChange={(e) => setStatusValue(e.target.value)}
                placeholder="Select Status"
                itemTemplate={optionTemplate}
                valueTemplate={selectedItemTemplate}
            />
            <span className="p-input-icon-right">
                <i className="pi pi-search" />
                <InputText
                    className="Input__Round ml-3"
                    placeholder="Search..."
                    value={globalFilterValue}
                    onChange={onGlobalFilterChange}
                />
            </span>
        </div>
    }
    responsive={true}
    filters={filters}
    globalFilterFields={[
        "partName",
        "partVariantName",
        "quantity",
        "partCost"
    ]}
    responsiveLayout="scroll"
    stripedRows
    value={allInventory}
    emptyMessage="No records found"
    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
>
    <Column
        field="partName"
        header="Part Name"
        style={{ width: "150px" }}
        body={(rowData) => rowData?.partName || "N/A"}
    />
    <Column
        field="partVariantName"
        header="Variant Name"
        style={{ width: "150px" }}
        body={(rowData) => rowData?.partVariantName || "N/A"}
    />
    <Column
        field="quantity"
        header="Quantity"
        style={{ width: "150px" }}
        body={(rowData) => rowData?.quantity ?? "N/A"}
    />
    <Column
        field="partCost"
        header="Part Cost"
        style={{ width: "150px" }}
        body={(rowData) => (rowData?.partCost ? `${rowData.partCost}` : "N/A")}
    />
    {!userRole?.toLowerCase().includes("user") && (
        <Column
            body={(rowData) => (
                <div className="flex justify-content-center">
                    <InputSwitch
                        className="edit-btn ml-1 mt-2"
                        checked={rowData?.partIsActive == "1"}
                        onChange={() => {
                            handleSwitchModalOpen();
                            setSwitchData(rowData);
                        }}
                    />
                </div>
            )}
            header="Status"
            style={{ width: "90px" }}
        />
    )}
    <Column
        header="Action"
        body={actionTemplate}
        style={{ width: "150px" }}
    />
</DataTable>

                    </div>

                    {/* {inventoryFilter == "part" ? (
                        <div className="card-ml-1 dark-bg">
                            <DataTable
                                header={
                                    <div className="flex justify-content-end custom-alignment">
                                        {" "}
                                        <span className="mr-2 font-semibold text-base resp-status">Status:</span>
                                        <Dropdown
                                            className=""
                                            style={{ width: "215px" }}
                                            options={statusOptions}
                                            optionLabel="name"
                                            optionValue="id"
                                            value={statusValue}
                                            onChange={(e) => setStatusValue(e.target.value)}
                                            placeholder="Select Status"
                                            itemTemplate={optionTemplate}
                                            valueTemplate={selectedItemTemplate}
                                        />
                                        <span className="p-input-icon-right">
                                            <i className="pi pi-search" />
                                            <InputText className="Input__Round ml-3" placeholder="Search..." value={globalFilterValue} onChange={onGlobalFilterChange} />
                                        </span>
                                    </div>
                                }
                                responsive={true}
                                filters={filters}
                                globalFilterFields={["partName", "variantMakerName", "variantModelName", "variantYear", "variantCategoryName", "quantity", "variantName", "partCost"]}
                                responsiveLayout="scroll"
                                stripedRows
                                value={filteredInventory}
                                emptyMessage="No records found"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            >
                                <Column field="variantMakerName" header="Maker" body={(rowData) => rowData?.variantMakerName || "N/A"} style={{ width: "150px" }}></Column>
                                <Column field="variantModelName" header="Model" style={{ width: "150px" }}></Column>
                                <Column field="variantYear" header="Year" style={{ width: "150px" }}></Column>
                                <Column field="variantName" header="Variant Name" style={{ width: "150px" }}></Column>
                                <Column field="variantCategoryName" header="Category" style={{ width: "150px" }}></Column>
                                <Column field="partName" header="Part Name" style={{ width: "150px" }}></Column>
                                <Column field="quantity" header="Quantity" style={{ width: "150px" }}></Column>
                                <Column body={partCostTemplate} header="Part Cost" style={{ width: "150px" }}></Column>
                                {!userRole?.toLowerCase().includes("user") && <Column body={statusTemplate} header="Status" style={{ width: "90px" }}></Column>}
                                <Column header="Action" body={actionTemplate} style={{ width: "150px" }} />
                            </DataTable>
                        </div>
                    ) : (
                        <div className="card-ml-1 dark-bg">
                            <DataTable
                                header={
                                    <div className="flex justify-content-end custom-alignment">
                                        <span className="mr-2 font-semibold text-base resp-status">Status:</span>
                                        <Dropdown
                                            className=""
                                            style={{ width: "215px" }}
                                            options={statusOptions}
                                            optionLabel="name"
                                            optionValue="id"
                                            value={statusValue}
                                            onChange={(e) => setStatusValue(e.target.value)}
                                            placeholder="Select Status"
                                            itemTemplate={optionTemplate}
                                            valueTemplate={selectedItemTemplate}
                                        />
                                        <span className="p-input-icon-right">
                                            <i className="pi pi-search" />
                                            <InputText className="Input__Round ml-3" placeholder="Search..." value={globalFilterValue} onChange={onGlobalFilterChange} />
                                        </span>
                                    </div>
                                }
                                responsive={true}
                                filters={filters}
                                globalFilterFields={["variantName", "variantMakerName", "variantModelName", "variantYear", "variantCategoryName", "quantity", "variantCost"]}
                                responsiveLayout="scroll"
                                stripedRows
                                value={filteredInventory}
                                emptyMessage="No records found"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            >
                                <Column field="variantMakerName" body={(rowData) => rowData?.variantMakerName || "N/A"} header="Variant Maker" style={{ width: "150px" }}></Column>
                                <Column field="variantModelName" header="Variant Model" style={{ width: "150px" }}></Column>
                                <Column field="variantYear" header="Variant Year" style={{ width: "150px" }}></Column>
                                <Column field="variantName" header="Variant Name" style={{ width: "150px" }}></Column>
                                <Column field="variantCategoryName" header="Category" style={{ width: "150px" }}></Column>
                                <Column field="quantity" header="Quantity" style={{ width: "150px" }}></Column>
                                <Column body={variantCostTemplate} header="Variant Cost" style={{ width: "150px" }}></Column>
                                {!userRole?.toLowerCase().includes("user") && <Column body={statusTemplate} header="Status" style={{ width: "90px" }}></Column>}
                                <Column header="Action" body={actionTemplate} style={{ width: "150px" }} />
                            </DataTable>
                        </div>
                    )} */}
                    {/* <Paginator totalPageCount={totalPageCount} currentPage={currentPage} recordCount={recordCount} setRecordCount={setRecordCount} setCurrentPage={setCurrentPage} setTotalPageCount={setTotalPageCount} quotationsCount={quotationsCount} /> */}
                    <Paginator setRecordCount={setRecordCount} setCurrentPage={setCurrentPage} setTotalPageCount={setTotalPageCount} recordCount={recordCount} currentPage={currentPage} totalPageCount={totalPageCount} quotationsCount={quotationsCount} />
                </>
            )}
        </>
    );
};

export default InventoryCart;
